export const ACTIVE_REPORT_EXPORT_ACTION = "ExportActiveReportJSON";

export const ACTIVE_REPORT_TYPES = [
  "Artwork",
  "Consignment",
  "Contact",
  "Exhibition",
  "Instance",
  "Invoice",
  "Job",
  "Offer",
  "Shipment",
  "WarehouseItem",
];

export const activeReportExportInput = ({
  correlationId,
  from,
  limit,
  offset,
  reportTemplateId,
  reportType,
  to,
  userId,
}) => ({
  action: ACTIVE_REPORT_EXPORT_ACTION,
  ...(correlationId?.trim() ? { correlationId: correlationId.trim() } : {}),
  ...(from ? { from } : {}),
  ...(reportTemplateId ? { reportTemplateId: Number(reportTemplateId) } : {}),
  ...(reportType ? { reportType } : {}),
  ...(to ? { to } : {}),
  ...(userId ? { userId: Number(userId) } : {}),
  limit,
  offset,
});

export const activeReportExportLabel = changeLog => {
  const type = changeLog?.meta?.input?.type || "Unknown type";
  const reportTemplateId = changeLog?.meta?.reportTemplateId;
  return `${type} · Template ${reportTemplateId ? `#${reportTemplateId}` : "unknown"}`;
};

export const activeReportExportScope = changeLog => {
  const { input = {}, resolvedIds = [], result = {} } = changeLog?.meta || {};
  const itemCount = Number.isFinite(result.itemCount)
    ? result.itemCount
    : result.ids?.length || 0;
  const itemLabel = `${itemCount} item${itemCount === 1 ? "" : "s"}`;

  if (input.listId) return `${itemLabel} · List #${input.listId}`;
  if (input.search && Object.keys(input.search).length > 0) {
    return `${itemLabel} · Search`;
  }
  const selectedCount = input.ids?.length || resolvedIds.length;
  return selectedCount ? `${itemLabel} · ${selectedCount} selected` : itemLabel;
};

export const formatActiveReportDuration = durationMs => {
  if (!Number.isFinite(durationMs)) return "—";
  if (durationMs < 1000) return `${durationMs}ms`;
  if (durationMs < 60000) return `${(durationMs / 1000).toFixed(1)}s`;

  const minutes = Math.floor(durationMs / 60000);
  const seconds = Math.round((durationMs % 60000) / 1000);
  return seconds ? `${minutes}m ${seconds}s` : `${minutes}m`;
};
